import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'KubeForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "name",
      label: "kube.form.name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          placeholder: _ctx.$t('kube.form.name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "number",
      label: "kube.form.number"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "number",
          modelValue: _ctx.form.number,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.number) = $event)),
          placeholder: _ctx.$t('kube.form.number'),
          type: "number"
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})